import { createFileRoute } from '@tanstack/react-router';

import { ConsolidatedReportPage } from '@/features/nis2/components/ConsolidatedReportPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/consolidated')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ConsolidatedReportPage />
      </div>
    </div>
  );
}
